// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../../../types";

import gql from "graphql-tag";
import { BookingEnquiryDetailsEventFragmentDoc } from "./EnquiryDetails/EnqiuryDetails.generated-types";
import { ProposalsEventFragmentDoc } from "./Proposals/Proposals.generated-types";
import { UseDateTimeDurationEventFragmentDoc } from "../../../../Hooks/useDateTimeDuration/useDateTimeDuration.generated-types";
import { GetStatusesEventFragmentDoc } from "../../../../Graphql-Utilities/getStatuses/getStatuses.generated-types";
import {
  RequestedProposalEventFragmentDoc,
  RequestedProposalProposalFragmentDoc,
} from "./RequestedProposal/RequestedProposal.generated-types";
export type InProgressBookingEventFragment = {
  __typename?: "Event";
  UUID: string;
  name: string;
  submittedAt: string;
  budget: number;
  attendees: number;
  location: string;
  currency: string;
  cateringNeeds?: string | null;
  additionalNotes?: string | null;
  fromDateTime: string;
  toDateTime: string;
  proposalCount: number;
  status: Types.EventStatus;
  layoutID: string;
  proposals: Array<{
    __typename?: "Proposal";
    UUID: string;
    invitationID: number;
    status: Types.ProposalStatus;
    hasPreferredVenue: boolean;
    ID: number;
    currency: string;
    baseCostTotal: number;
    baseCostDescription: string;
    message?: string | null;
    space: {
      __typename?: "SelfServeSpace";
      spaceName?: string | null;
      description?: string | null;
      spacePhotos?: Array<{
        __typename?: "SelfServeSpacePhoto";
        url?: string | null;
      }> | null;
      venue?: {
        __typename?: "SelfServeVenue";
        name?: string | null;
        addressLine1?: string | null;
        city?: string | null;
        postalCode?: string | null;
        nearestTransit?: {
          __typename?: "NearestTransit";
          station?: string | null;
        } | null;
      } | null;
      spatialConfigurations?: Array<{
        __typename?: "SelfServeSpatialConfiguration";
        name?: string | null;
        capacity?: number | null;
      }> | null;
      spaceFeatures?: Array<{
        __typename?: "SelfServeSpaceFeature";
        ID?: number | null;
        name?: string | null;
      }> | null;
    };
    extraCostItems?: Array<{
      __typename?: "ExtraCostItem";
      ID: number;
      description: string;
      quantity?: number | null;
      costPerUnit: number;
    }> | null;
    documents?: Array<{
      __typename?: "ProposalDocument";
      ID: number;
      URL: string;
      filename: string;
    }> | null;
  }>;
  invitations?: Array<{
    __typename?: "Invitation";
    ID: number;
    declinedAt?: string | null;
  }> | null;
  spaceFacilities?: Array<{
    __typename?: "SpaceFacility";
    id: number;
    name: string;
  }> | null;
};

export type InProgressBookingProposalFragment = {
  __typename?: "Proposal";
  status: Types.ProposalStatus;
  hasPreferredVenue: boolean;
  ID: number;
  currency: string;
  baseCostTotal: number;
  baseCostDescription: string;
  message?: string | null;
  space: {
    __typename?: "SelfServeSpace";
    spaceName?: string | null;
    description?: string | null;
    hostContact: {
      __typename?: "HostContact";
      email?: string | null;
      phoneNumber?: string | null;
    };
    spacePhotos?: Array<{
      __typename?: "SelfServeSpacePhoto";
      url?: string | null;
    }> | null;
    venue?: {
      __typename?: "SelfServeVenue";
      name?: string | null;
      addressLine1?: string | null;
      city?: string | null;
      postalCode?: string | null;
      nearestTransit?: {
        __typename?: "NearestTransit";
        station?: string | null;
      } | null;
    } | null;
    spatialConfigurations?: Array<{
      __typename?: "SelfServeSpatialConfiguration";
      name?: string | null;
      capacity?: number | null;
    }> | null;
    spaceFeatures?: Array<{
      __typename?: "SelfServeSpaceFeature";
      ID?: number | null;
      name?: string | null;
    }> | null;
  };
  extraCostItems?: Array<{
    __typename?: "ExtraCostItem";
    ID: number;
    description: string;
    quantity?: number | null;
    costPerUnit: number;
  }> | null;
  documents?: Array<{
    __typename?: "ProposalDocument";
    ID: number;
    URL: string;
    filename: string;
  }> | null;
};

export const InProgressBookingEventFragmentDoc = gql`
  fragment InProgressBookingEvent on Event {
    UUID
    name
    proposals {
      UUID
      invitationID
      status
    }
    invitations {
      ID
      declinedAt
    }
    submittedAt
    ...BookingEnquiryDetailsEvent
    ...ProposalsEvent
    ...RequestedProposalEvent
    ...UseDateTimeDurationEvent
    ...GetStatusesEvent
  }
  ${BookingEnquiryDetailsEventFragmentDoc}
  ${ProposalsEventFragmentDoc}
  ${RequestedProposalEventFragmentDoc}
  ${UseDateTimeDurationEventFragmentDoc}
  ${GetStatusesEventFragmentDoc}
`;
export const InProgressBookingProposalFragmentDoc = gql`
  fragment InProgressBookingProposal on Proposal {
    ...RequestedProposalProposal
  }
  ${RequestedProposalProposalFragmentDoc}
`;
